import * as R from 'ramda'
import { combineActions, handleActions } from 'redux-actions'

import a from './actions'

const init = {
  language: 'en',
  country: 'gb',
  countries: [],
  translations: {}
}

const setLanguageActions = combineActions('CORE/REQUESTER/FETCH', a.language.set)

export default handleActions({
  [setLanguageActions]: (state, { error, payload = {} }) => {
    return error
      ? state
      : {
        ...state,
        ...R.pick(['language'], payload)
      }
  }
}, init)
